import { render, staticRenderFns } from "./EsgGhgEmissionMgmtByScope.vue?vue&type=template&id=0649df93&scoped=true"
import script from "./EsgGhgEmissionMgmtByScope.vue?vue&type=script&lang=js"
export * from "./EsgGhgEmissionMgmtByScope.vue?vue&type=script&lang=js"
import style0 from "./EsgGhgEmissionMgmtByScope.vue?vue&type=style&index=0&id=0649df93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649df93",
  null
  
)

export default component.exports